export default "__VITE_ASSET__BFqrkmKB__"